import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

export interface CrmCostAgentRow {
  agent_id: string | null;
  name: string;
  is_active: boolean;
  cost_nok: number;
  signals: number;
  claimed: number;
  dismissed: number;
  cost_cap_reached: boolean;
}

export interface CrmCostCustomerRow {
  customer_id: string;
  name: string;
  cost_nok: number;
}

/** Svaret fra RPC crm_cost_summary(p_month), admin. Kostnadene er i NOK. */
export interface CrmCostSummary {
  month: string;
  total_nok: number;
  apify_nok: number;
  claude_nok: number;
  sms_nok: number;
  monitored_customers: number;
  runs: number;
  failed_runs: number;
  per_agent: CrmCostAgentRow[];
  per_customer: CrmCostCustomerRow[];
}

/** Kostnadsoversikt for én måned ('YYYY-MM'). Aggregeringen skjer i databasen. */
export function useCrmCostSummary(month: string, options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: ["crm-costs", month],
    queryFn: async (): Promise<CrmCostSummary> => {
      const { data, error } = await supabase.rpc("crm_cost_summary", { p_month: month });
      if (error) throw error;
      return data as CrmCostSummary;
    },
    enabled: !!month && (options.enabled ?? true),
    staleTime: 5 * 60 * 1000,
  });
}
